import ScalarMarkdown_vue_vue_type_script_setup_true_lang_default from "./ScalarMarkdown.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                   */
//#region src/components/ScalarMarkdown/ScalarMarkdown.vue
var ScalarMarkdown_default = ScalarMarkdown_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarMarkdown_default as default };

//# sourceMappingURL=ScalarMarkdown.vue.js.map